export default __webpack_public_path__ + "static/media/learnmore-rank.35241f20.svg";